var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-end h-100 pb-3"},[_c('span',{staticClass:"ml-1"},[_vm._t("checkbox")],2),_vm._t("selection-count")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }